export const onMapModalOpen = new CustomEvent("mapopen");

export const onMapModalClose = new CustomEvent("mapclose");

export const onMapInputChanges = new CustomEvent("mapinputchange");
